import React, { useState, useRef, useEffect } from "react";
import showdown from "showdown";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import ProjectEditTabs from "./project-edit/ProjectEditTabs";
import TravelEditTable from "./TravelEditTable";

import ViewTravelRequests from "./ViewTravelRequests";


function ChatbotModal({ onClose }) {
  const baseUrl = process.env.REACT_APP_API_BASE_URL;
  const [pendingCount, setPendingCount] = useState(0);

  const [travelRequests, setTravelRequests] = useState([]);
  const [showTravelEdit, setShowTravelEdit] = useState(false);


  const [messages, setMessages] = useState([
    {
      text: "Hello! I'm your Analytics Assistant. What would you like to explore today?",
      sender: "ai",
    },
  ]);


  const [showTravelView, setShowTravelView] = useState(false);
  const [showTravelOptions, setShowTravelOptions] = useState(false);
  const [input, setInput] = useState("");
  const [file, setFile] = useState(null);
  const [showPrompts, setShowPrompts] = useState(true);
  const chatboxRef = useRef(null);
  const converter = new showdown.Converter();
  const user = JSON.parse(localStorage.getItem("user"));

  console.log(user);


  const [showProjectOptions, setShowProjectOptions] = useState(false); // New state
  const textareaRef = useRef(null); // New ref
  const [showEditDropdown, setShowEditDropdown] = useState(false);
  const [allProjects, setAllProjects] = useState([]);

  const [showFinancePage, setShowFinancePage] = useState(false);
  const [showChatbot, setShowChatbot] = useState(true);


  // changes made today 
  const [inManualEntryMode, setInManualEntryMode] = useState(false); // get back to buttons logic
  // const [inManualEntryMode, setInManualEntryMode] = useState(false);

  const isEmployee = user?.role === "Employee";
  const isFinance = user?.role === "Finance Manager";
  const isAdmin = user?.role === "Admin";
  const isCxO = user?.role === "CxO";
  const isProjectManager = user?.role === "Project Manager";




  const [selectedProjectData, setSelectedProjectData] = useState(null);

  const handleProjectSelect = async (projectName) => {
    try {
      const selected = allProjects.find(p => p.project_name === projectName);
      const res = await fetch(`${baseUrl}/project_details/${selected.project_id}`);
      const fullData = await res.json();
      console.log("Fetched project data:", fullData);
      // Wrap in 'project' key because your UI expects selectedProjectData.project.project_name
      setSelectedProjectData(fullData);
      setShowEditDropdown(false);
      setShowProjectOptions(false);
    } catch (error) {
      console.error("❌ Failed to load project details", error);
    }
  };

  // till here

  useEffect(() => {
    if (chatboxRef.current) {
      chatboxRef.current.scrollTop = chatboxRef.current.scrollHeight;
    }
  }, [messages]);

  const handleDownloadPreviewAsExcel = async (previewData) => {
    const worksheet = XLSX.utils.json_to_sheet(previewData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
    const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
    const blob = new Blob([excelBuffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    // Check if File System Access API is available
    if ('showSaveFilePicker' in window) {
      try {
        const options = {
          suggestedName: `Generated_data${new Date().getTime()}.xlsx`,
          types: [
            {
              description: 'Excel Files',
              accept: { 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': ['.xlsx'] },
            },
          ],
        };

        const handle = await window.showSaveFilePicker(options);
        const writable = await handle.createWritable();
        await writable.write(blob);
        await writable.close();
        console.log("File saved successfully.");
      } catch (error) {
        console.error("User cancelled or error:", error);
      }
    } else {
      // fallback for unsupported browsers
      saveAs(blob, `Generated_data${new Date().getTime()}.xlsx`);
    }
  };



  const handleDownloadChartImage = async (chartPath) => {
    try {
      const imageUrl = `${baseUrl}/${chartPath.replace(/\\\\/g, "/")}`;
      const response = await fetch(imageUrl);
      const blob = await response.blob();
      const fileName = `Generated_chart_${Date.now()}.png`;

      // ✅   Modern browsers with File System Access API
      if ('showSaveFilePicker' in window) {
        const options = {
          suggestedName: fileName,
          types: [
            {
              description: 'PNG Image',
              accept: { 'image/png': ['.png'] },
            },
          ],
        };

        const handle = await window.showSaveFilePicker(options);
        const writable = await handle.createWritable();
        await writable.write(blob);
        await writable.close();
        console.log("✅ Chart saved successfully.");
      } else {
        // ✅ Fallback: Use file-saver
        saveAs(blob, fileName);
      }
    } catch (error) {
      console.error("❌ Failed to download chart:", error);
    }
  };


  const handleSend = async (customText) => {
    const finalInput = customText ?? input.trim();
    if (!finalInput && !file) return;
    if (showPrompts) setShowPrompts(false);

    const userMessage = file
      ? `File uploaded: ${file.name}\n\n${finalInput}`
      : finalInput;

    setMessages((prev) => [...prev, { text: userMessage, sender: "user" }]);
    setInput("");
    setFile(null);

    try {
      let endpoint = "chat";
      if (isEmployee || isFinance || isAdmin) {
        endpoint = "chat_travel";
      }

      // Prepare request body
      const requestBody = {
        message: userMessage,
        role: user?.role || "",
      };

      // Add extra fields if role is Employee
      if (isEmployee || isFinance || isAdmin) {
        requestBody.eid = user.eid;
        requestBody.name = `${user.fname} ${user.lname}`;
      }

      const response = await fetch(`${baseUrl}/${endpoint}`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(requestBody),
      });

      const data = await response.json();

      let rawMessage =
        data.response?.message ||
        data.response?.sql ||
        (typeof data.response === "string"
          ? data.response
          : JSON.stringify(data.response, null, 2)) ||
        "✅ Success";

      const html = converter.makeHtml(rawMessage);

      const aiMessage = {
        text: html,
        sender: "ai",
        isHTML: true,
        preview: Array.isArray(data.response.preview) ? data.response.preview : [],
        chart: data.response.chart || "",
        excel: data.response.excel || "",
      };

      setMessages((prev) => [...prev, aiMessage]);
    }
    catch (error) {
      console.error("Chatbot error:", error);
      setMessages((prev) => [
        ...prev,
        {
          text: "⚠️ Something went wrong while contacting the AI assistant.",
          sender: "ai",
        },
      ]);
    }
  };

  const handlePromptClick = (prompt) => {
    if (isCxO && prompt === "Organisation Dashboard") {
      setShowPrompts(false);
      setInManualEntryMode(true);
      setTimeout(() => textareaRef.current?.focus(), 100);
      return;
    }

    if (prompt === "Project Management") {
      setShowPrompts(false);
      setShowProjectOptions(true);
      return;
    }

    if (prompt === "Travel Management") {
      setShowPrompts(false);
      setShowTravelOptions(true);
      return;
    }

    // 🔄 For all other prompts, just send directly
    handleSend(prompt);
  };

const fetchPendingCount = async () => {
  if (isFinance || isAdmin) {
    try {
      const res = await fetch(`${baseUrl}/travel_request?role=${user.role}`);
      const data = await res.json();
      setPendingCount(data.length); //  Set the updated count
    } catch (error) {
      console.error("❌ Failed to fetch pending travel requests:", error);
    }
  }
};


useEffect(() => {
  fetchPendingCount();
}, [user?.role]);


  // useEffect(() => {
  //   const fetchPendingCount = async () => {
  //     if (isFinance || isAdmin) {
  //       try {
  //         const res = await fetch(`${baseUrl}/travel_request?role=${user.role}`);
  //         const data = await res.json();
  //         setPendingCount(data.length); // ✅ Count based on status 1 or 2, as per role
  //       } catch (error) {
  //         console.error("❌ Failed to fetch pending travel requests:", error);
  //       }
  //     }
  //   };

  //   fetchPendingCount();
  // }, [user?.role]);



  const fetchTravelRequests = async () => {
    try {
      let query = "";

      if (user?.role === "Employee" || user?.role === 3) {
        query = `?role=Employee&eid=${user.eid}`;
      } else if (user?.role === "Admin") {
        query = `?role=Admin`;
      } else if (user?.role === "Finance Manager") {
        query = `?role=Finance`;
      } else {
        query = ``; // For CxO or unknown roles, get all
      }

      const res = await fetch(`${baseUrl}/travel_request${query}`);
      const data = await res.json();

      setTravelRequests(data);
      setShowChatbot(false);
      setShowTravelEdit(true);
    } catch (err) {
      console.error("❌ Failed to fetch travel requests:", err);
    }
  };





  if (showTravelEdit) {
    return (
      <div className="fixed inset-0 bg-white z-50 flex flex-col">
        <div className="flex items-center justify-between p-2 border-b bg-blue-100">
          <h3 className="text-lg font-semibold text-blue-800 mx-auto">
            Travel Request Editor
          </h3>
          <button
            onClick={() => {
              setShowChatbot(true);
              setShowTravelEdit(false);
            }}
            className="text-xl text-gray-700 font-bold hover:text-red-600"
          >
            ✖
          </button>
        </div>

        <TravelEditTable
          data={travelRequests}
          onUpdate={fetchTravelRequests}
          onRefreshCount={fetchPendingCount}
          onClose={() => {
            setShowChatbot(true);
            setShowTravelEdit(false);
          }}
        />
      </div>
    );
  }




  return (
    <div id="chatbot" className="fixed inset-0 bg-white z-50 flex flex-col">
      {/* Header */}
      <div className="flex items-center justify-between p-2 border-b bg-blue-100 relative">
        <div className="absolute left-4">
          <img
            src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSCvntqFKtz5Oj1YslX8cnX8jZ3kiTKtytxl8MI-IlHYtM300Y-g4q73A_9eydwRun4v6A&usqp=CAU"
            alt="Logo"
            className="h-8 w-8 object-contain rounded-md"
          />
        </div>
        <h3 className="text-lg font-semibold text-blue-800 mx-auto">Chat Assistant</h3>
        <button
          onClick={onClose}
          className="absolute right-4 text-xl text-gray-700 font-bold hover:text-red-600"
        >
          ✖
        </button>
      </div>

      {/* Chat content */}
      <div className="flex-1 flex flex-col overflow-hidden">
        <div
          className="flex-1 px-6 py-4 overflow-auto space-y-4 flex flex-col"
          ref={chatboxRef}
        >
          {messages.map((msg, idx) => (
            <div
              key={idx}
              className={`p-4 rounded-md max-w-xl whitespace-pre-wrap break-words ${msg.sender === "user" ? "self-end bg-green-100" : "self-start bg-gray-200"
                }`}
            >
              {msg.isHTML ? (
                <div dangerouslySetInnerHTML={{ __html: msg.text }} />
              ) : (
                <p>{msg.text}</p>
              )}

              {msg.preview && msg.preview.length > 0 && (
                <div className="relative mt-4">
                  {/* For medium and larger screens: Traditional table */}
                  <div className="hidden md:block overflow-x-auto max-h-64 rounded shadow border border-gray-200 custom-scrollbar">
                    <table className="min-w-full text-sm text-left table-auto border-collapse">
                      <thead className="bg-blue-100 sticky top-0 z-10">
                        <tr>
                          {Object.keys(msg.preview[0]).map((col) => (
                            <th
                              key={col}
                              className="px-4 py-2 text-gray-700 font-semibold border-b border-blue-200 whitespace-nowrap"
                            >
                              {col}
                            </th>
                          ))}
                        </tr>
                      </thead>
                      <tbody className="bg-white divide-y divide-gray-100">
                        {msg.preview.map((row, i) => (
                          <tr key={i} className="hover:bg-gray-50 transition-colors">
                            {Object.values(row).map((val, j) => (
                              <td
                                key={j}
                                className="px-4 py-2 text-gray-800 whitespace-nowrap max-w-[200px] overflow-hidden text-ellipsis"
                              >
                                {val}
                              </td>
                            ))}
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>

                  {/* For small screens: Card view */}
                  <div className="block md:hidden space-y-4">
                    {msg.preview.map((row, i) => (
                      <div
                        key={i}
                        className="bg-white border border-gray-200 rounded-lg shadow p-4 space-y-2"
                      >
                        {Object.entries(row).map(([key, value], j) => (
                          <div key={j} className="flex justify-between text-sm">
                            <span className="font-medium text-gray-600">{key}</span>
                            <span className="text-gray-800 text-right max-w-[50%] truncate">
                              {value}
                            </span>
                          </div>
                        ))}
                      </div>
                    ))}
                  </div>

                  {/* Download Button (same across devices) */}
                  <div className="mt-4">
                    <button
                      onClick={() => handleDownloadPreviewAsExcel(msg.preview)}
                      className="bg-green-600 hover:bg-green-700 text-white px-4 py-2 rounded shadow text-sm"
                    >
                      ⬇️ Download Data In Excel File
                    </button>
                  </div>
                </div>
              )}


              {msg.chart && (
                <div className="mt-4 space-y-2">
                  <img
                    src={`${baseUrl}/${msg.chart.replace(/\\\\/g, "/")}`}
                    alt="Chart"
                    className="max-w-full h-auto border rounded"
                  />

                  <button
                    onClick={() => handleDownloadChartImage(msg.chart)}
                    className="bg-green-600 hover:bg-green-700 text-white px-4 py-2 rounded shadow text-sm"
                  >
                    ⬇️ Download Chart Image
                  </button>
                </div>
              )}



              <span className="text-xs text-gray-500 block mt-2">
                {new Date().toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" })}
              </span>
            </div>
          ))}
        </div>

        {/* Quick Prompts */}
        {showPrompts && (
          <div className="bg-white px-4 py-3 border-t border-gray-200">
            <p className="text-gray-700 text-lg font-semibold text-center mb-3">
              Quick Prompts
            </p>
            <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-7 gap-2 justify-center">
              {[
                "HR Management",
                "Project Management",
                "Vendor Management",
                "Client Management",
                "Travel Management",
                "Accounting",
                "Organisation Dashboard",
              ].map((prompt, index) => {
                const colors = [
                  "bg-blue-100 hover:bg-blue-200 text-blue-800",
                  "bg-green-100 hover:bg-green-200 text-green-800",
                  "bg-yellow-100 hover:bg-yellow-200 text-yellow-800",
                  "bg-pink-100 hover:bg-pink-200 text-pink-800",
                  "bg-purple-100 hover:bg-purple-200 text-purple-800",
                  "bg-indigo-100 hover:bg-indigo-200 text-indigo-800",
                  "bg-orange-100 hover:bg-orange-200 text-orange-800",
                ];
                const colorClass = colors[index % colors.length];


                const isDisabled =
                  isEmployee
                    ? prompt !== "Travel Management"
                    : isProjectManager
                    ? prompt !== "Project Management"
                    : isFinance
                      ? !["Travel Management", "Accounting"].includes(prompt)
                      : isCxO
                        ? !["Organisation Dashboard"].includes(prompt)
                        : isAdmin
                          ? !["Travel Management"].includes(prompt)
                          : false;



                return (
                  <button
                    key={prompt}
                    onClick={() => handlePromptClick(prompt)}
                    className={`relative px-2 py-2 rounded-md text-xs sm:text-sm shadow font-medium ${colorClass} ${isDisabled ? "cursor-not-allowed opacity-50" : "cursor-pointer"}`}
                    disabled={isDisabled}
                    title={isDisabled ? "Access restricted for your role" : ""}
                  >
                    {prompt}

                    {/* ✅ Add badge for pending count on Travel Management */}
                    {prompt === "Travel Management" && (isFinance || isAdmin) && pendingCount > 0 && (
                      <span className="absolute -top-2 -right-2 bg-red-600 text-white text-[10px] font-bold px-1.5 py-0.5 rounded-full">
                        {pendingCount}
                      </span>
                    )}
                  </button>

                );
              })}

            </div>
          </div>
        )}

        {/* Add, Edit and Search btns */}
        {showProjectOptions && (
          <div className="bg-white px-4 py-3 border-t border-gray-200">
            <p className="text-gray-700 text-sm font-semibold text-center mb-3">
              Project Management Options
            </p>
            <div className="flex justify-center gap-3 flex-wrap">
              <button
                className="bg-blue-100 hover:bg-blue-200 font-bold text-blue-800 px-3 py-2 rounded-md text-sm shadow"
                onClick={() => {
                  setShowEditDropdown(false); // <--- Add this line
                  setShowProjectOptions(false);     // Hide options
                  setInManualEntryMode(true); //  Track that user is in manual mode
                  setTimeout(() => textareaRef.current?.focus(), 100); // Focus textarea
                }}
              >
                Add Project
              </button>

              <button
                className="bg-yellow-100 hover:bg-yellow-200 font-bold text-yellow-800 px-3 py-2 rounded-md text-sm shadow"
                onClick={async () => {
                  try {
                    const res = await fetch(`${baseUrl}/projects`);
                    const data = await res.json();
                    setAllProjects(data);
                    setShowEditDropdown(true);
                  } catch (error) {
                    console.error("❌ Failed to fetch projects", error);
                  }
                }}
              >
                Edit Project
              </button>
              <button
                className="bg-green-100 hover:bg-green-200  font-bold text-green-800 px-3 py-2 rounded-md text-sm shadow"
                onClick={() => {
                  setShowEditDropdown(false); // 
                  setShowProjectOptions(false);
                  setInManualEntryMode(true); // 
                  // setInput("Search project ");
                  setTimeout(() => textareaRef.current?.focus(), 100);
                }}
              >
                Search Project
              </button>
            </div>
          </div>
        )}
        {showTravelOptions && (
          <div className="bg-white px-4 py-3 border-t border-gray-200">
            <p className="text-gray-700 text-sm font-semibold text-center mb-3">
              Travel Management
            </p>
            <div className="flex justify-center gap-3 flex-wrap">
              {/* Employee: Raise Request */}
              {isEmployee && (
                <>
                  <button
                    className="bg-purple-100 hover:bg-purple-200 font-bold text-purple-800 px-3 py-2 rounded-md text-sm shadow"
                    onClick={() => {
                      setShowTravelOptions(false);
                      setInManualEntryMode(true);
                      setTimeout(() => textareaRef.current?.focus(), 100);
                    }}
                  >
                    Raise a Travel Request
                  </button>
                  <button
                    className="bg-blue-100 hover:bg-blue-200 font-bold text-blue-800 px-3 py-2 rounded-md text-sm shadow"
                    onClick={async () => {
                      try {
                        const res = await fetch(`${baseUrl}/travel_request?role=Employee&eid=${user.eid}`);
                        const data = await res.json();
                        setTravelRequests(data);
                        setShowTravelOptions(false);
                        setShowTravelView(true); // this should be in your state
                      } catch (err) {
                        console.error("❌ Failed to fetch travel requests:", err);
                      }
                    }}
                  >
                    View Travel Request
                  </button>
                </>
              )}
              {/* Finance or Admin: Approve Requests */}
              {(isFinance || isAdmin) && (
                <div className="relative inline-block">
                  <button
                    className="bg-green-100 hover:bg-green-200 font-bold text-green-800 px-3 py-2 rounded-md text-sm shadow"
                    onClick={async () => {
                      try {
                        const res = await fetch(`${baseUrl}/travel_request`);
                        const data = await res.json();
                        setTravelRequests(data);
                        setShowChatbot(false);
                        setShowFinancePage(false);
                        setShowTravelEdit(true);
                      } catch (error) {
                        console.error("❌ Failed to fetch travel requests:", error);
                      }
                    }}
                  >
                    Approve Travel Request
                  </button>
                  {pendingCount > 0 && (
                    <span className="absolute -top-2 -right-2 bg-red-600 text-white text-xs font-bold px-2 py-0.5 rounded-full">
                      {pendingCount}
                    </span>
                  )}
                </div>
              )}
            </div>
          </div>
        )}



        {/* Dynamic project list in dropdown menu */}
        {showEditDropdown && (
          <div className="mt-3 w-full sm:w-1/3 mb-2 mx-auto">
            <select
              className="w-full border px-3 py-2 rounded shadow"
              onChange={(e) => {
                const selected = e.target.value;
                if (selected !== "") {
                  handleProjectSelect(selected);  // fetch and set project data
                  setShowProjectOptions(false);
                  setShowEditDropdown(false);
                  setTimeout(() => textareaRef.current?.focus(), 100);
                }
              }}
              defaultValue=""
            >
              <option value="" disabled>Select a project</option>
              {allProjects.map((proj) => (
                <option key={proj.project_id} value={proj.project_name}>
                  {proj.project_name}
                </option>
              ))}
            </select>
          </div>
        )}
        {/* changes made today */}
        {selectedProjectData && selectedProjectData.project && (
          <div className="px-4 py-4">
            <h2 className="text-lg font-semibold text-center text-blue-700 mb-4">
              Editing Project: {selectedProjectData.project.project_name}
            </h2>

            <ProjectEditTabs
              data={selectedProjectData}
              onDataUpdate={(updated) => setSelectedProjectData(updated)}
              onMinimize={() => {
                setSelectedProjectData(null);            // Hide the tabs
                setShowProjectOptions(true);             // Show Add/Edit/Search again
              }}
            />
            <div className="text-right pr-4 mt-4">
              <button
                onClick={async () => {
                  try {
                    const res = await fetch(`${baseUrl}/update_project/${selectedProjectData.project.project_id}`, {
                      method: "PUT",
                      headers: { "Content-Type": "application/json" },
                      body: JSON.stringify(selectedProjectData),
                    });

                    const result = await res.json();

                    if (res.ok) {
                      // ✅ Refresh the updated project data
                      const refreshed = await fetch(`${baseUrl}/project_details/${selectedProjectData.project.project_id}`);
                      // const updatedProjectData = await refreshed.json();


                      setSelectedProjectData(null); // ⬅️ Hide the form after update

                      // ✅ Append a success message to chat
                      setMessages(prev => [
                        ...prev,
                        {
                          text: "✅ Project updated successfully.",
                          sender: "ai",
                          isHTML: false,
                          isLocalMessage: true,
                        },
                      ]);

                      // ✅ Reset UI flags
                      setShowProjectOptions(true);
                      setShowEditDropdown(false);
                      setInManualEntryMode(false);
                      setInput("");
                    } else {
                      alert("Update failed: " + (result.message || "Unknown error"));
                    }
                  } catch (err) {
                    console.error("❌ Update failed:", err);
                    alert("❌ Update failed, check console");
                  }
                }}
                className="bg-blue-600 hover:bg-blue-700 text-white px-3 py-1 rounded shadow"
              >
                Update Project
              </button>
            </div>

          </div>
        )}
        {/* till here */}

        {/* Input Section */}
        <div className="px-6 py-3 bg-white border-t border-gray-200">
          <div className="flex items-end gap-3 relative">
            {/* Back button (⬆️) only when inManualEntryMode */}
            {inManualEntryMode && !isCxO && (
              <button
                onClick={() => {
                  setInManualEntryMode(false);
                  setInput("");

                  if (isEmployee) {
                    setShowTravelOptions(true);
                  } else if (isFinance || isAdmin) {
                    setShowTravelOptions(true);
                  } else {
                    setShowProjectOptions(true);
                  }
                }}
                title="Back"
                className="bg-yellow-100 hover:bg-yellow-200 text-yellow-800 font-bold px-2 py-2 rounded-md shadow"
              >
                ⬆️
              </button>
            )}

            {showTravelView && (
              <div className="fixed inset-0 bg-white z-50 flex flex-col">
                <div className="flex items-center justify-between p-2 border-b bg-blue-100">
                  <h3 className="text-lg font-semibold text-blue-800 mx-auto">
                    Travel Requests Viewer
                  </h3>
                  <button
                    onClick={() => {
                      setShowTravelOptions(true);
                      setShowTravelView(false);
                    }}
                    className="text-xl text-gray-700 font-bold hover:text-red-600"
                  >
                    ✖
                  </button>
                </div>

                <ViewTravelRequests
                  data={travelRequests}
                  onClose={() => {
                    setShowTravelOptions(true);
                    setShowTravelView(false);
                  }}
                />
              </div>
            )}



            {/* Show entire input area (Upload, Textarea, Send) only in manual mode */}
            {inManualEntryMode && (
              <>
                {/* Upload file */}
                <input
                  type="file"
                  id="fileInput"
                  className="hidden"
                  onChange={(e) => setFile(e.target.files[0])}
                />
                <label
                  htmlFor="fileInput"
                  className="cursor-pointer bg-gray-100 px-3 py-2 rounded-md hover:bg-gray-200 shadow"
                >
                  ➕
                </label>

                {/* Textarea */}
                <div className="flex-1 border rounded-md p-2 bg-gray-50 shadow-sm">
                  {file && (
                    <div className="mb-2 flex items-center justify-between bg-gray-100 rounded p-2">
                      <div className="flex items-center gap-2">
                        <img
                          src={
                            file.type.startsWith("image/")
                              ? URL.createObjectURL(file)
                              : "https://via.placeholder.com/40?text=FILE"
                          }
                          className="w-10 h-10 object-cover rounded border"
                          alt="preview"
                        />
                        <span className="text-sm text-gray-700 truncate w-40">
                          {file.name}
                        </span>
                      </div>
                      <button
                        className="text-red-500 hover:text-red-700"
                        onClick={() => setFile(null)}
                      >
                        ✕
                      </button>
                    </div>
                  )}
                  <textarea
                    rows="1"
                    ref={textareaRef}
                    placeholder="Ask about analytics use cases, data strategies, or upload files..."
                    value={input}
                    onChange={(e) => setInput(e.target.value)}
                    onKeyDown={(e) => {
                      if (e.key === "Enter" && !e.shiftKey) {
                        e.preventDefault();
                        handleSend();
                      }
                    }}
                    className="w-full resize-none overflow-hidden bg-transparent outline-none"
                  ></textarea>
                </div>

                {/* Send button */}
                <button
                  onClick={() => handleSend()}
                  className="bg-blue-500 text-white px-4 py-2 rounded-md hover:bg-blue-600 shadow"
                >
                  ➤
                </button>
              </>
            )}


          </div>
        </div>

      </div>
    </div>
  );
}
export default ChatbotModal;
